import React from 'react';
import { PrimaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import { Person } from 'talent_matching/types';
import useAdvanceCandidate from 'talent_matching/hooks/use_advance_candidate';

const t = withLocalePrefix('talent_matching');

type Props = {
  application: Person;
  canAdvance?: boolean;
  onSuccess?: () => void;
};

const AdvanceButton = ({
  application,
  canAdvance = true,
  onSuccess,
}: Props) => {
  const advanceCandidate = useAdvanceCandidate('side_panel');

  const handleAdvance = () => {
    advanceCandidate(application, onSuccess);
  };

  return (
    <PrimaryButton onClick={handleAdvance} size="md" disabled={!canAdvance}>
      {t('advance')}
    </PrimaryButton>
  );
};

export default AdvanceButton;
